var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33594 11.3336H10.6693",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33594 8.66696H8.0026",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66406 1.66698V2.00032C8.66406 3.88594 8.66406 4.82874 9.24986 5.41453C9.83566 6.00031 10.7785 6.00032 12.6641 6.00032H12.9974M13.3307 7.10492V9.33365C13.3307 11.8478 13.3307 13.1049 12.5497 13.8859C11.7687 14.667 10.5115 14.667 7.9974 14.667C5.48324 14.667 4.22616 14.667 3.44511 13.8859C2.66406 13.1049 2.66406 11.8478 2.66406 9.33365V6.30421C2.66406 4.14086 2.66406 3.05919 3.25478 2.32654C3.37412 2.17852 3.50894 2.0437 3.65695 1.92436C4.3896 1.33365 5.47128 1.33365 7.6346 1.33365C8.105 1.33365 8.34013 1.33365 8.55553 1.40966C8.60033 1.42546 8.6442 1.44365 8.68706 1.46415C8.89313 1.56268 9.0594 1.72898 9.392 2.06157L12.5497 5.21927C12.9351 5.60464 13.1277 5.79733 13.2293 6.04235C13.3307 6.28738 13.3307 6.55988 13.3307 7.10492Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.43645dd7ea6df2bece905449bd54953f.svg";
export { ForwardRef as ReactComponent };